import { clsx } from "clsx";
import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { OverlayContainer } from "react-aria";

import { Shortcut } from "../Shortcut/Shortcut.tsx";
import { TooltipIntent } from "./settings.ts";
import style from "./Tooltip.module.css";

export interface TooltipProps {
  children?: ReactNode; // for forwardRef
  domProps: HTMLAttributes<Element>;
  arrowProps?: HTMLAttributes<Element>;
  title?: string;
  shortcut?: string;
  intent?: TooltipIntent;
  /** Will replace the children. Use the children for complex content. */
  content?: ReactNode;
}

/**
 * @deprecated
 * to be used with DEPRECATED_useTooltip
 */
export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props: TooltipProps, ref) {
  return (
    <OverlayContainer>
      <div
        role="tooltip"
        className={clsx(style.tooltip, {
          [style.light]: props.intent == null || props.intent === TooltipIntent.Default,
          [style.info]: props.intent === TooltipIntent.Info,
          [style.warning]: props.intent === TooltipIntent.Warning,
          [style.danger]: props.intent === TooltipIntent.Danger,
        })}
        {...props.domProps}
        ref={ref}
        data-testid={"tooltip"}
      >
        {props.title != undefined && (
          <div className={style.header}>
            <div className={style.title}>{props.title}</div>
            {props.shortcut != undefined && <Shortcut label={props.shortcut} />}
          </div>
        )}
        <div className={style.with_shortcut}>
          <div className={style.content}>{props.content || props.children}</div>
          {!props.title && props.shortcut != undefined && <Shortcut label={props.shortcut} />}
        </div>
        {props.arrowProps != undefined && <div className={style.arrow} {...props.arrowProps} />}
      </div>
    </OverlayContainer>
  );
});
